// Get the base API URL, stripping /api if present since admin-frontend adds it where needed
const getApiBaseUrl = (): string => {
    const envUrl =
        (process.env.NEXT_PUBLIC_API_BASEURL as string) ||
        'http://localhost:3001'
    // Remove /api suffix if present - admin-frontend adds /api where needed
    return envUrl.endsWith('/api') ? envUrl.slice(0, -4) : envUrl
}

// NEXT_PUBLIC_VERCEL_ENV is 'production' for the production deploys of ANY Vercel
// project, including the staging one, so it cannot distinguish environments on
// its own. NEXT_PUBLIC_APP_ENV is the explicit signal; when it is unset the
// value derives from VERCEL_ENV exactly as before, so existing deployments are
// unchanged.
const getAppEnv = (): 'production' | 'staging' | 'development' => {
    const explicit = process.env.NEXT_PUBLIC_APP_ENV
    if (explicit === 'production' || explicit === 'staging') {
        return explicit
    }
    return process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
        ? 'production'
        : 'development'
}

const APP_ENV = getAppEnv()

export const CONFIG = {
    API_BASEURL: getApiBaseUrl(),
    APP_ENV,
    IS_PRODUCTION: APP_ENV === 'production',
    IS_STAGING: APP_ENV === 'staging',
    SELF_SERVE_DISABLED: process.env.NEXT_PUBLIC_SELF_SERVE_DISABLED === 'true',
} as const
